export default __webpack_public_path__ + "static/media/abbeville11.c1037149.jpg";